// removed by extract-text-webpack-plugin
module.exports = {"container":"QRCodes__container__162Zw","contentBox":"QRCodes__contentBox__1dx3V","boxBtnPickers":"QRCodes__boxBtnPickers__THufT","boxRightSection":"QRCodes__boxRightSection__1POLe","boxQrSection":"QRCodes__boxQrSection__1qnFS","boxPrintBtn":"QRCodes__boxPrintBtn__3cRu8","chooseCodeBtn":"QRCodes__chooseCodeBtn__M5cAa","printCodeBtn":"QRCodes__printCodeBtn__1kLYG","activeBtn":"QRCodes__activeBtn__Re2fQ","clearFix":"QRCodes__clearFix__1fuwj"};


//////////////////
// WEBPACK FOOTER
// ./src/Containers/AdminScreens/QRCodes/QRCodes.css
// module id = 586
// module chunks = 0